import { UserSettings } from "@/components/Dialogs/UserSettings";
import { User } from "types";

export default function VerifyEmailAlert({ socket, streamerMode, user }: { socket: any, streamerMode: any, user: User }) {
    return (
        <>
            {(socket && !streamerMode?.enabled && !user.verified) && (
                <div className="w-screen bg-gradient-to-r from-orange-600 to-orange-500 sm:-ml-4 sm:-mr-4">
                    <div className="flex flex-col sm:flex-row items-center justify-center font-medium py-1">
                        <p className="text-white text-sm">
                            Please verify your email to unlock all features.
                        </p>
                        <UserSettings user={{ user }} socket={socket}>
                            <button className="text-white font-semibold border px-4  rounded-lg text-sm ml-4"
                            >
                                Verify Email
                            </button>
                        </UserSettings>
                    </div>
                </div>
            )}
        </>
    )
}
